import jsPDF from 'jspdf';
import { PDF_COLORS } from '../../config/colors';
import { PDF_FONTS, PDF_LAYOUT } from '../../config/fonts';
import { PageManager } from '../../helpers/pageBreaks';
import { getRecommendations } from './utils/RecommendationUtilities';
import { testData } from '../../../../data/testData';

export class CategoryRecommendationsComponent {
  private pdf: jsPDF;
  private pageManager: PageManager;

  constructor(pdf: jsPDF, pageManager: PageManager) {
    this.pdf = pdf;
    this.pageManager = pageManager;
  }

  render(category: any, priority: number): void {
    const categoryInfo = testData.find(c => c.id === category.categoryId);
    if (!categoryInfo) return;

    const recommendations = getRecommendations(category.categoryId, 'priority').slice(0, 3);
    const detailedRecs = getRecommendations(category.categoryId, 'detailed').slice(0, 2);

    this.renderCategoryHeader(categoryInfo, category, priority);
    this.renderRecommendationSubsection('Immediate Actions:', recommendations);
    this.pageManager.enforceMinimumSpacing(12);
    this.renderRecommendationSubsection('Detailed Strategies:', detailedRecs);
    this.pageManager.addSection();
  }

  private renderCategoryHeader(categoryInfo: any, category: any, priority: number): void {
    const headerHeight = 25;
    
    this.pageManager.checkForPageBreak(headerHeight + 60, {
      minSpaceAfter: 40,
      elementType: `priority-${priority}-category`,
    });

    this.pdf.setFont(PDF_FONTS.primary, 'bold');
    this.pdf.setFontSize(PDF_FONTS.size.body);
    this.pdf.setTextColor(...PDF_COLORS.error);
    this.pdf.text(
      `Priority ${priority}: ${categoryInfo.title} (${Math.round(category.percentage)}%)`,
      PDF_LAYOUT.margins.left,
      this.pageManager.getCurrentY()
    );

    this.pageManager.addElement(PDF_FONTS.size.body, {
      spacingAfter: PDF_LAYOUT.spacing.line,
      elementType: `priority-${priority}-header`,
    });
  }

  private renderRecommendationSubsection(title: string, recommendations: string[]): void {
    this.pageManager.checkForPageBreak(30, {
      minSpaceAfter: 20,
      elementType: 'recommendation-subsection',
    });

    // Subsection title
    this.pdf.setFont(PDF_FONTS.primary, 'bold');
    this.pdf.setFontSize(PDF_FONTS.size.small);
    this.pdf.setTextColor(...PDF_COLORS.text.primary);
    this.pdf.text(
      title,
      PDF_LAYOUT.margins.left + 5,
      this.pageManager.getCurrentY()
    );

    this.pageManager.addElement(PDF_FONTS.size.small, {
      spacingAfter: PDF_LAYOUT.spacing.line,
      elementType: 'subsection-header',
    });

    // Recommendation items
    this.pdf.setFont(PDF_FONTS.primary, 'normal');
    this.pdf.setTextColor(...PDF_COLORS.text.secondary);

    recommendations.forEach((rec, index) => {
      const recLines = this.pdf.splitTextToSize(
        `• ${rec}`,
        this.pageManager.getContentWidth() - 15
      );
      const recHeight = recLines.length * PDF_FONTS.size.body * 1.2 + 5;

      this.pageManager.checkForPageBreak(recHeight + 15, {
        minSpaceAfter: 15,
        elementType: 'recommendation-item',
      });

      recLines.forEach((line: string) => {
        this.pdf.text(line, PDF_LAYOUT.margins.left + 10, this.pageManager.getCurrentY());
        this.pageManager.addLine();
      });

      if (index < recommendations.length - 1) {
        this.pageManager.enforceMinimumSpacing(6);
      }
    });
  }
}